import React from "react";

/**
 * Unified modal content wrapper for consistent styling
 * Use this inside ModalNew for standardized gap, padding, and layout
 * PopupHeader should be placed outside of this component
 */
const UnifiedModal = ({
  children,
  modalFormProps = {},
}) => {
  return (
    <div className="modal-form unified-modal-form" style={{ display: "flex", flexDirection: "column", flex: 1, minHeight: 0 }} {...modalFormProps}>
      {children}
    </div>
  );
};

export default UnifiedModal;
